var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7520_3201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.505992 14.471L7.80999 1.81836C8.73777 2.37106 13.4162 4.99088 14.1718 5.48914L6.86777 18.1424C6.06898 19.2103 -0.506008 16.0914 0.505992 14.4703V14.471Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4916 14.4697L14.1876 1.81791C13.1665 0.0984295 10.9673 -0.52644 9.16103 0.489125C7.35471 1.50469 6.80471 3.69234 7.82582 5.4886L15.1298 18.142C16.1509 19.8607 18.3502 20.4855 20.1565 19.47C21.8838 18.4543 22.5127 16.1891 21.4916 14.4712V14.4697Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66644 19.9581C5.69136 19.9581 7.33288 18.3384 7.33288 16.3404C7.33288 14.3424 5.69136 12.7227 3.66644 12.7227C1.64152 12.7227 0 14.3424 0 16.3404C0 18.3384 1.64152 19.9581 3.66644 19.9581Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7520_3201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGAds);
export default __webpack_public_path__ + "static/media/g_ads.a9352838c45e5afa442ddc9338355df5.svg";
export { ForwardRef as ReactComponent };